// extracted by mini-css-extract-plugin
export default {"numeric-fields-grid":"style_numeric-fields-grid__Osw2C"};